import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../appstate';
import { Observable } from 'rxjs';
import { PlayerHomeData } from './player-home-data';
import { PlayerHomeInfo } from '../../data/player-data';
import { filter } from 'rxjs/operators';
/**
 * Created by ashok on 11/05/17.
 */

@Injectable()
export class PlayerHomeDataService {
  constructor(private store: Store<AppState>) {}

  public playerHomeData(): Observable<PlayerHomeData> {
    return this.store
      .select((appState: any) => appState.reducers.playerHomeData)
      .pipe(filter(Boolean));
  }
  // public playerHomeInfo(): Observable<PlayerHomeInfo> {
  //      return this.store.select((appState:any)=>{

  //         return appState.reducers.playerHomeData.playerHome
  //     }
  //     );
  // }
  public playerHomeInfo(): Observable<PlayerHomeInfo> {
    return this.store.select((appState: any) => {
      // console.debug("state player home info : ", appState)
      return appState.reducers.playerHomeData.playerHome;
    });
  }
  public competitionSelected(): Observable<any> {
    //was  nyumber here
    return this.store
      .select((appState: any) => appState.reducers.playerHomeData.competitionSelectedForScoring)
      .pipe(filter(Boolean));
  }
  public competitionSelectedForScoring(): Observable<any> {
    return this.store
      .select((appState: any) => appState.reducers.playerHomeData.selectedCompetition)
      .pipe(filter(Boolean));
  }
  public playerName(): Observable<string> {
    return this.store.select(
      (appState: any) => appState.reducers.playerHomeData.playerHome.playerName
    );
  }
  public playerPhoto(): Observable<string> {
    return this.store.select((appState: any) => {
      // console.debug('state player photo : ', appState);
      if (
        appState.reducers.playerHomeData &&
        appState.reducers.playerHomeData.playerHome &&
        appState.reducers.playerHomeData.playerHome.player
      ) {
        // if (appState.reducers.playerHomeData.playerHome.player.thumbnail)
        //   return appState.reducers.playerHomeData.playerHome.player.thumbnail;
        if (appState.reducers.playerHomeData.playerHome.player.photoUrl)
          return appState.reducers.playerHomeData.playerHome.player.photoUrl;
        else return '';
      } else return '';
    });
  }
}
